import { z } from 'zod/v4'

// Hyphen-notation variant (for workflow YAML files)
export const UIControlSchema = z
  .object({
    type: z
      .enum(['input', 'text-area', 'select', 'checkbox', 'radio', 'file'])
      .optional(),
    placeholder: z.string().optional(),
    'default-value': z.union([z.string(), z.boolean()]).optional(),
    options: z
      .array(z.object({ label: z.string(), value: z.string() }))
      .optional(),
    'help-text': z.string().optional(),
    'data-type': z
      .enum([
        'string',
        'number',
        'boolean',
        'date',
        'json',
        'communication-channel',
        'file',
      ])
      .optional(),
  })
  .transform((val) => ({
    type: val.type,
    placeholder: val.placeholder,
    defaultValue: val['default-value'],
    options: val.options,
    helpText: val['help-text'],
    dataType: val['data-type'],
  }))

export type UIControl = z.infer<typeof UIControlSchema>
